import Login from '../components/Login';

export default function signup() {
  return (
    <>
      <Login
        heading="Sign up, it’s free"
        buttonText="Get signup code"
        accessType="signup"
      />
    </>
  );
}

export const getServerSideProps = async () => {
  return {
    props: {}
  };
};
